import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import { styleMap as i } from './../../external/lit-html/directives/style-map.js';
import ButtonCss from "./ButtonCss.js";
class Button extends s {
  static get styles() {
    return [ButtonCss];
  }
  static get properties() {
    return {
      type: { type: String },
      variant: { type: String },
      disabled: { type: Boolean },
      icon: { type: String },
      size: { type: String },
      width: { type: String },
      text: { type: String },
      title: { type: String }
    };
  }
  constructor() {
    super();
    this.type = "button";
    this.variant = "secondary";
  }
  render() {
    var _a;
    const style = this.icon ? y`
      <style>@import '${iscecoWidgetLibrary.iconCss}';</style>
    ` : "";
    const icon = this.icon ? y`<i class="${this.icon} icon" ?disabled="${this.disabled}"></i>` : "";
    return y`
      ${style}
      <div>
        <button @click="${(e) => this.disabled ? e.stopPropagation() : ""}"
                type="${this.type}"
                ?disabled="${this.disabled}"
                class="${this.variant} ${this.size}"
                title="${(_a = this.title) != null ? _a : " "}"
                style="${i({ width: this.width })}">
          ${icon}
          ${this.text}
        </button>
      </div>
    `;
  }
}
customElements.define("isceco-button", Button);
export { Button };
